define("settings/components/modal-form", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <form {{action (perform @task) on="submit"}}>
  
    {{yield
      (hash
        input=(component "modal/form-input")
        footer=(component
          "modal/form-footer"
          isDisabled=(or @task.isRunning @isDisabled)
          isRunning=@task.isRunning
          runningText=@runningText
          cancel=@cancel
        )
      )
    }}
  </form>
  */
  {
    "id": "vPEIXvQZ",
    "block": "[[[11,\"form\"],[4,[38,0],[[30,0],[28,[37,1],[[30,1]],null]],[[\"on\"],[\"submit\"]]],[12],[1,\"\\n\\n  \"],[18,5,[[28,[37,3],null,[[\"input\",\"footer\"],[[50,\"modal/form-input\",0,null,null],[50,\"modal/form-footer\",0,null,[[\"isDisabled\",\"isRunning\",\"runningText\",\"cancel\"],[[28,[37,5],[[30,1,[\"isRunning\"]],[30,2]],null],[30,1,[\"isRunning\"]],[30,3],[30,4]]]]]]]]],[1,\"\\n\"],[13]],[\"@task\",\"@isDisabled\",\"@runningText\",\"@cancel\",\"&default\"],false,[\"action\",\"perform\",\"yield\",\"hash\",\"component\",\"or\"]]",
    "moduleName": "settings/components/modal-form.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});